'use strict';

//FAST YOUTUBE INC MOD (kijk uit met default script gebruik)

function Album(albumElement, nextprev) {
	this.albumElement = albumElement;
	this.overlayElement = null;
	this.viewerElement = null;
	this.currentElement = null;
	this.currentContentElement = null;
	this.nextprev = nextprev;
	this.nextprev = typeof nextprev !== 'undefined' ? nextprev : true;

	if (this.albumElement.nodeName == 'A') {
		this.aElements = [this.albumElement];
	} else {
		this.aElements = this.albumElement.getElementsByTagName('a');
	}

	var _this = this;
	for (var i = 0; i < this.aElements.length; i++) {
		this.aElements[i].addEventListener('click', function (e) {
			_this.openViewer(e);
		}, false);
		this.aElements[i].setAttribute('data-href', this.aElements[i].getAttribute('href'));
		//this.aElements[i].removeAttribute('href');
	}

	if (this.nextprev) {
		document.addEventListener('keydown', function (e) {
			_this.nextPic(e);
		}, false);
		document.addEventListener('keydown', function (e) {
			_this.prevPic(e);
		}, false);
		document.addEventListener('keydown', function (e) {
			_this.removeViewer(e);
		}, false);
	}
}

Album.prototype.openViewer = function (e) {
	e.preventDefault();

	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	}

	while (target.nodeName != 'A') {
		target = target.parentNode;
	}

	this.currentElement = target;
	this.makeViewer();
	var _this = this;
};

Album.prototype.makeViewer = function () {
	var bodyElement = document.getElementsByTagName('body')[0];

	var _this = this;

	this.overlayElement = document.createElement('div');
	this.overlayElement.setAttribute('id', 'overlay');

	this.overlayElement.addEventListener('click', function (e) {
		_this.removeViewer(e);
	}, false);

	this.viewerElement = document.createElement('div');
	this.viewerElement.setAttribute('id', 'viewer');

	this.viewerElement.addEventListener('click', function (e) {
		_this.removeViewer(e);
	}, false);

	if (this.currentElement.getAttribute('data-href').match(/\/watch\?v=/)) {
		var urlParts = this.currentElement.getAttribute('data-href').split('?v=');
		if (urlParts.length != 2) {
			alert('Fout bij het weergeven van de video.');
		}

		var contentElement = document.createElement('iframe');
		contentElement.setAttribute('src', '//www.youtube.com/embed/' + urlParts[urlParts.length - 1] + '?autoplay=1');
		contentElement.setAttribute('width', '960');
		contentElement.setAttribute('height', '540');
		this.currentContentElement = contentElement;
		this.viewerElement.appendChild(contentElement);
	} else if (this.currentElement.getAttribute('data-href').match(/archive.org\/details/)) {
		var urlParts = this.currentElement.getAttribute('data-href').split('/details/');

		if (urlParts.length != 2) {
			alert('Fout bij het weergeven van de video.');
		}
		var contentElement = document.createElement('iframe');
		contentElement.setAttribute('src', 'https://archive.org/embed/' + urlParts[urlParts.length - 1]);
		contentElement.setAttribute('width', '960');
		contentElement.setAttribute('height', '540');
		this.currentContentElement = contentElement;
		this.viewerElement.appendChild(contentElement);
	} else if (this.currentElement.getAttribute('data-href').match(/vara.nl\/media/)) {
		var urlParts = this.currentElement.getAttribute('data-href').split('/media/');

		if (urlParts.length != 2) {
			alert('Fout bij het weergeven van de video.');
		}
		var contentElement = document.createElement('iframe');
		contentElement.setAttribute('src', '//media-service.vara.nl/player.php?id=' + urlParts[urlParts.length - 1]);
		contentElement.setAttribute('width', '960');
		contentElement.setAttribute('height', '540');
		this.currentContentElement = contentElement;
		this.viewerElement.appendChild(contentElement);
	} else {
		var contentElement = document.createElement('img');
		contentElement.setAttribute('src', this.currentElement.getAttribute('data-href'));
		this.currentContentElement = contentElement;
		this.viewerElement.appendChild(contentElement);
	}

	contentElement.addEventListener('load', function (e) {
		_this.loadedPic(e);
	}, false);

	var offset = window.pageYOffset || document.documentElement.scrollTop || bodyElement.scrollTop || 0;
	this.viewerElement.setAttribute('style', 'top: ' + offset + 'px;');

	if (this.aElements.length > 1 && this.nextprev) {
		var nextElement = document.createElement('div');
		nextElement.setAttribute('id', 'nextPic');
		nextElement.addEventListener('click', function (e) {
			_this.nextPic(e);
		}, false);

		var prevElement = document.createElement('div');
		prevElement.setAttribute('id', 'prevPic');
		prevElement.addEventListener('click', function (e) {
			_this.prevPic(e);
		}, false);

		this.viewerElement.appendChild(nextElement);
		this.viewerElement.appendChild(prevElement);
	}

	var closeElement = document.createElement('div');
	closeElement.setAttribute('id', 'closePic');
	closeElement.addEventListener('click', function (e) {
		_this.removeViewer(e);
	}, false);
	this.viewerElement.appendChild(closeElement);

	bodyElement.appendChild(this.overlayElement);
	bodyElement.appendChild(this.viewerElement);
};

Album.prototype.removeViewer = function (e) {
	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	}

	if (target == this.viewerElement || target == this.overlayElement || target == document.getElementById('closePic') || e.keyCode == 27) {
		this.overlayElement.parentNode.removeChild(this.overlayElement);
		this.viewerElement.parentNode.removeChild(this.viewerElement);
	}
};

Album.prototype.nextPic = function (e) {
	if (e.type == 'keydown' && e.keyCode != 39) {
		return;
	}
	for (var i = 0; i < this.aElements.length; i++) {
		if (this.aElements[i] == this.currentElement) {
			var maxNo = this.aElements.length - 1;
			var nextNo = i + 1;
			if (i == maxNo) {
				this.currentElement = this.aElements[0];
				break;
			} else {
				this.currentElement = this.aElements[nextNo];
				break;
			}
		}
	}

	this.setPic();
};

Album.prototype.prevPic = function (e) {
	if (e.type == 'keydown' && e.keyCode != 37) {
		return;
	}
	for (var i = 0; i < this.aElements.length; i++) {
		if (this.aElements[i] == this.currentElement) {
			var maxNo = this.aElements.length - 1;
			if (i == 0) {
				this.currentElement = this.aElements[maxNo];
				break;
			} else {
				this.currentElement = this.aElements[i - 1];
				break;
			}
		}
	}

	this.setPic();
};

Album.prototype.setPic = function (e) {
	this.currentContentElement.parentNode.removeChild(this.currentContentElement);

	if (this.currentElement.getAttribute('data-href').match(/\/watch\?v=/)) {
		var urlParts = this.currentElement.getAttribute('data-href').split('?v=');
		if (urlParts.length != 2) {
			alert('Fout bij het weergeven van de video.');
		}

		this.currentContentElement = document.createElement('iframe');
		this.currentContentElement.setAttribute('src', '//www.youtube.com/embed/' + urlParts[urlParts.length - 1]);
		this.currentContentElement.setAttribute('width', '960');
		this.currentContentElement.setAttribute('height', '540');
		this.viewerElement.appendChild(this.currentContentElement);
	} else if (this.currentElement.getAttribute('data-href').match(/archive.org\/details/)) {
		var urlParts = this.currentElement.getAttribute('data-href').split('/details/');

		if (urlParts.length != 2) {
			alert('Fout bij het weergeven van de video.');
		}
		var contentElement = document.createElement('iframe');
		contentElement.setAttribute('src', 'https://archive.org/embed/' + urlParts[urlParts.length - 1]);
		contentElement.setAttribute('width', '960');
		contentElement.setAttribute('height', '540');
		this.currentContentElement = contentElement;
		this.viewerElement.appendChild(contentElement);
	} else if (this.currentElement.getAttribute('data-href').match(/vara.nl\/media/)) {
		var urlParts = this.currentElement.getAttribute('data-href').split('/media/');

		if (urlParts.length != 2) {
			alert('Fout bij het weergeven van de video.');
		}
		var contentElement = document.createElement('iframe');
		contentElement.setAttribute('src', '//media-service.vara.nl/player.php?id=' + urlParts[urlParts.length - 1]);
		contentElement.setAttribute('width', '960');
		contentElement.setAttribute('height', '540');
		this.currentContentElement = contentElement;
		this.viewerElement.appendChild(contentElement);
	} else {
		this.currentContentElement = document.createElement('img');
		this.viewerElement.appendChild(this.currentContentElement);
		var _this = this;
		this.currentContentElement.addEventListener('load', function (e) {
			_this.loadedPic(e);
		}, false);

		this.currentContentElement.setAttribute('class', 'unloaded');
		this.currentContentElement.setAttribute('src', this.currentElement.getAttribute('data-href'));
	}
};

Album.prototype.loadedPic = function (e) {
	this.currentContentElement.removeAttribute('class');
};